import { NOOP } from '@chegg-wt/core/constants/global'
import { AppState } from '@chegg-wt/core/state'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Style } from '@chegg-wt/core/types/styles-api'
import { styleSelected } from '@chegg-wt/core/state/currentProject/actions'
import { loadStyles, stylesRequested } from '@chegg-wt/core/state/styles/actions'
import {
  currentStyleSelector,
  currentStyleNameSelector,
} from '@chegg-wt/core/state/currentProject/selectors'
import { stylesPageSelector, stylesSelector } from '@chegg-wt/core/state/styles/selectors'
import { userRoleSelector } from '../../state/user/selectors'
import { TriggerProps, DropdownAlignment } from '../Select'
import FilterSelect from '../FilterSelect'
import { UserRole, UserRoles } from '../../constants/user'

interface Props {
  currentStyle: string
  currentStyleName: string
  loadStyles: () => void
  styleSelected: (
    styleId: string,
    skipSoftGate: boolean,
    allowStyleChange: boolean
  ) => void
  styles: Style[]
  stylesPage: number
  stylesRequested: (query: string, page?: number) => void
  trigger: React.FC<TriggerProps>
  dropdownAlignment?: DropdownAlignment
  onSelectCallback?: (id?: string, name?: string) => void
  userRole?: UserRole
}

export const StyleSelect: React.FC<Props> = ({
  currentStyle,
  currentStyleName,
  loadStyles,
  styleSelected,
  styles,
  stylesRequested,
  stylesPage,
  trigger,
  dropdownAlignment,
  onSelectCallback = NOOP,
  userRole,
}) => {
  const [filter, setFilter] = useState('')

  const onClose = () => {
    setFilter('')
    loadStyles()
  }

  const onFilter = (query: string) => {
    setFilter(query)
    stylesRequested(query)
  }

  const onScrollToBottom = () => {
    stylesRequested(filter, stylesPage + 1)
  }

  const onSelect = (id: string, name: string) => {
    onSelectCallback(id, name)
    /*
    If the userRole is free, we dont want to block changing of styles for citation list that exists before the time of
    feature release and citation list with gated style can only be be created before release of style gate or by paid
    users after release. Therefore we have want to allow style change using style gate for such cases.

    For Paid User this value will go as false, which will result in running of current existing flow.
    */
    const allowStyleChange = userRole === UserRoles.FREE_USER
    styleSelected(id, false, allowStyleChange)
  }

  useEffect(() => {
    loadStyles()
  }, [])

  return (
    <FilterSelect
      onClose={onClose}
      onFilter={onFilter}
      onSelect={onSelect}
      onScrollToBottom={onScrollToBottom}
      options={styles}
      defaultOption={{ name: currentStyleName, id: currentStyle }}
      trigger={trigger}
      dropdownAlignment={dropdownAlignment}
      type="citation-styles"
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  currentStyle: currentStyleSelector(state),
  currentStyleName: currentStyleNameSelector(state),
  styles: stylesSelector(state),
  stylesPage: stylesPageSelector(state),
  userRole: userRoleSelector(state),
})

const mapDispatchToProps = {
  loadStyles,
  styleSelected,
  stylesRequested,
}

export default connect(mapStateToProps, mapDispatchToProps)(StyleSelect)
